/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Endpoint_Card_You_SendInputs */

const en_endpoint_card_you_send = /** @type {(inputs: Endpoint_Card_You_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You send`)
};

const zh_hans1_endpoint_card_you_send = /** @type {(inputs: Endpoint_Card_You_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你发送`)
};

const pt_br2_endpoint_card_you_send = /** @type {(inputs: Endpoint_Card_You_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Você envia`)
};

const es_endpoint_card_you_send = /** @type {(inputs: Endpoint_Card_You_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Envías`)
};

const fr_endpoint_card_you_send = /** @type {(inputs: Endpoint_Card_You_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vous envoyez`)
};

const de_endpoint_card_you_send = /** @type {(inputs: Endpoint_Card_You_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du sendest`)
};

const ru_endpoint_card_you_send = /** @type {(inputs: Endpoint_Card_You_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вы отправляете`)
};

const it_endpoint_card_you_send = /** @type {(inputs: Endpoint_Card_You_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu invii`)
};

/**
* | output |
* | --- |
* | "You send" |
*
* @param {Endpoint_Card_You_SendInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const endpoint_card_you_send = /** @type {((inputs?: Endpoint_Card_You_SendInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Endpoint_Card_You_SendInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_endpoint_card_you_send(inputs)
	if (locale === "pt-BR") return pt_br2_endpoint_card_you_send(inputs)
	if (locale === "es") return es_endpoint_card_you_send(inputs)
	if (locale === "fr") return fr_endpoint_card_you_send(inputs)
	if (locale === "de") return de_endpoint_card_you_send(inputs)
	if (locale === "ru") return ru_endpoint_card_you_send(inputs)
	if (locale === "it") return it_endpoint_card_you_send(inputs)
	return en_endpoint_card_you_send(inputs)
});